import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { getCookie } from '../services/cookies';
import { Layout } from 'antd';
import * as userActions from '../redux/actions/userActions';
import routeOptions from '../routes/route';
import { startTableWidthFixObserver } from '../common_functions/fixTableWidths';
import './App.less';

const { Content } = Layout;
const App = props => {
  useEffect(() => {
    startTableWidthFixObserver();
  }, []);
  const navigate = useNavigate();
  const location = useLocation();
  const ssfToken = getCookie('ssfToken');
  const ssftime = getCookie('ssfTime');
  const ssfrft = getCookie('ssfrft');
  const redirecToPublic = async () => {
    let { pathname, search } = location;
    let publicRoutes = routeOptions.publicRoutes;
    let isPathMatch = false;

    for (let i = 0; i < publicRoutes.length; i++) {
      let item = publicRoutes[i];
      if (item.path === pathname) {
        isPathMatch = true;
        navigate(pathname + search);
        break;
      }
    }
    if (!isPathMatch) {
      await props.signOut();
      navigate('/login');
    }
  };
  const isTokenExpired = () => {
    if (!ssfToken) {
      return true;
    }
  };
  useEffect(() => {
    (async () => {
      if (isTokenExpired()) {
        redirecToPublic();
      }
      if (ssftime !== 'undefined') {
        let newDate = new Date(ssftime);
        let cookieExpiryTime = newDate.getTime();
        let currentTime = new Date().getTime();

        if (ssfToken && cookieExpiryTime - currentTime > 180000) {
          await props.manualSignIn(ssfToken);
        } else if (ssfToken && cookieExpiryTime - currentTime <= 180000 && cookieExpiryTime - currentTime > 0) {
          if (ssfrft) {
            await props.refreshtoken(ssfrft);
          } else {
            redirecToPublic();
          }
        } else {
          redirecToPublic();
        }
      } else {
        redirecToPublic();
      }
    })();
  }, [ssfToken]);

  let publicRoutes = routeOptions.publicRoutes.map(({ path, component }) => (
    <Route key={path} path={path} element={React.createElement(component)} />
  ));

  let routes = routeOptions.routes.map(({ path, component: RouteComponent }) => (
    <Route
      key={path}
      path={path}
      element={
        isTokenExpired() ? (
          // Redirect to login page if the access token is expired
          <Navigate to="/login" replace />
        ) : (
          // Render the component if the access token is not expired
          <RouteComponent />
        )
      }
    />
  ));

  return (
    <div className="app-container App">
      <Layout>
        <Layout className="site-layout">
          <Content>
            <Routes>
              {publicRoutes}
              {routes}
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default connect(state => {
  return {
    ...state.status,
    ...state.user,
  };
}, userActions)(App);
